import { TableHeaders } from '@/shared/components/table/models';
import { boolToYN } from '@/utils/boolToYN';

export const VanRegularTableHeaders: TableHeaders[] = [
  { label: 'DATE', key: 'date' },
  { label: 'WO #', key: 'orderNumber' },
  { label: 'BILL TO', key: 'billTo' },
  {
    key: 'masterBillOfLading',
    label: 'M B/L'
  },
  {
    key: 'houseBillOfLading',
    label: 'House BL'
  },
  {
    key: 'referenceNumber',
    label: 'REF'
  },
  {
    key: 'poNumber',
    label: 'PO'
  },
  {
    key: 'deliveryNumber',
    label: 'DELIVERY #'
  },
  {
    key: 'trailNumber',
    label: 'Trailer #'
  },
  {
    key: 'containerType',
    label: 'Type'
  },
  {
    key: 'containerSize',
    label: 'SZ'
  },
  { label: 'SEAL #', key: 'seal' },
  { label: 'Commodity', key: 'commodity' },
  {
    key: 'weight',
    label: 'WGT'
  },
  {
    key: 'quantity',
    label: 'QTY'
  },
  {
    key: 'unit',
    label: 'Unit'
  },
  {
    key: 'eta',
    label: 'ETA'
  },
  {
    key: 'lastFreeDay',
    label: 'LFD'
  },
  {
    key: 'freeDays',
    label: 'Free Days'
  },
  {
    key: 'freeDaysType',
    label: 'FD Type'
  },
  {
    key: 'dropLive',
    label: 'Drop/Live'
  },
  {
    key: 'avaDsc',
    label: 'DSC',
    formatter: boolToYN
  },
  {
    key: 'avaOth',
    label: 'OTH',
    formatter: boolToYN
  },
  {
    key: 'overHeight',
    label: 'OH',
    formatter: boolToYN
  },
  {
    key: 'overWeight',
    label: 'OW',
    formatter: boolToYN
  },
  {
    key: 'haz',
    label: 'HAZ',
    formatter: boolToYN
  },
  {
    key: 'hot',
    label: 'HOT',
    formatter: boolToYN
  },
  {
    key: 'pulloutLocation',
    label: 'P/OUT'
  },
  {
    key: 'pulloutSchedule',
    label: 'S IN'
  },
  { label: 'DILV', key: 'deliveryLocation' },
  {
    key: 'deliverySchedule',
    label: 'S IN'
  },
  {
    key: 'returnLocation',
    label: 'RTN'
  },
  {
    key: 'returnSchedule',
    label: 'S IN'
  }
];
